<app-expansion-panel [titre]="'Indicateur de performance ' + idx()" [item]="form()" [isOpen]="true">
  <div class="px-lg pt-lg pb-xl gap-lg flex flex-col" [formGroup]="form()">
    <div hlmField>
      <label [for]="'indicateur' + idx()" hlmFieldLabel labelRequired>Nom de l'indicateur</label>
      <hlm-autocomplete
        [(search)]="search"
        [id]="'nom-' + idx()"
        [filteredOptions]="tousLesIndicateurs()"
        [optionTemplate]="option"
        [autocompleteSearchClass]="isFormInvalid() ? 'border-danger border' : 'border-grey-3 border'"
        (searchChange)="onSearchChange($event)"
        formControlName="indicateur"
      >
        <ng-template #option let-option>{{ option.nom }}</ng-template>
      </hlm-autocomplete>
      @if (form().get('indicateur')?.hasError('required') && form().get('nom')?.touched) {
        <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
      }
      @if (form().get('indicateur')?.hasError('notUnique')) {
        <hlm-field-error>Vous avez déjà sélectionné cet indicateur pour cet indice</hlm-field-error>
      }
    </div>

    <div hlmField>
      <label [for]="'select-indices' + idx()" hlmFieldLabel>Rattaché à</label>
      <hlm-select [id]="'select-indices-' + idx()" formControlName="indices" multiple>
        <hlm-select-trigger>
          <hlm-select-value />
        </hlm-select-trigger>

        <hlm-select-content>
          <hlm-input-group class="border-grey-3 text-grey-7">
            <input
              class="round-l-md"
              formControlName="nomIndice"
              placeholder="Rechercher par nom d'indice"
              type="text"
              hlmInputGroupInput
            />
            <hlm-input-group-addon align="inline-end">
              <ng-icon hlm name="lucideSearch" />
            </hlm-input-group-addon>
          </hlm-input-group>
          @for (group of indicesFiltres(); track $index) {
            <hlm-select-group>
              <hlm-select-label>{{ group.nom }}</hlm-select-label>
              @for (indice of group.items; track indice.id) {
                <hlm-option [value]="indice.id">
                  {{ indice.nom }}
                </hlm-option>
              }
            </hlm-select-group>
          }
        </hlm-select-content>
      </hlm-select>
    </div>
  </div>
</app-expansion-panel>
